import React from 'react';
import '../css/index.css';

export function Construction() {

    return(
        <section className="Construction" >

            <h2> This Content Is Currently Under Construction! Please Come Back Later!</h2>

            <div className='Husky'>
                <img src="./img/husky.png" alt="Italian Trulli"></img>
            </div>

            

        </section>
    )
}